<div class="d-flex justify-content-end flex-auto">
  <div class="add-as-accepted d-flex flex-column">
    <div class="accepted-action">
      <div class="d-flex flex-row flex-auto">
        <div class="accept-title d-flex flex-auto">{{'request_review.action_bar.title' | translate}}</div>
        <div class="accept-btn">
          <achoo-toggle-switch actionByLevels="Auto update groups"
                               [wallName]="'Request Review'"
                               [actionData]="eventDataForSegment()"
                               [(model)]="needToReview" (switchChange)="onSwitch()">
          </achoo-toggle-switch>
        </div>
      </div>
    </div>
    <div class="accepted-description">
      {{'request_review.action_bar.message' | translate}}
      <div class="reviewer-list" [ngClass]="{'disabled': !needToReview}">
        <span class="placeholder">{{placeholder}}</span>
        <achoo-filter-box #ReviewerList
                          [options]="reviewerList"
                          [multiple]="true"
                          [disabled]="!needToReview"
                          [makeSelectedItemOnTop]="false"
                          [closeDropdownWithoutFocusing]="true"
                          (selectEvent)="onSelectReviewer($event)"
                          (closeDropDownEvent)="onChangeReviewer($event)"
                          [(model)]="selectedReviewers">
        </achoo-filter-box>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/send-to-review/send-to-review.component.html